import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { MenuScene } from './scenes/MenuScene';
import { GameScene } from './scenes/GameScene';
import { HudScene } from './scenes/HudScene';
import { PauseScene } from './scenes/PauseScene';
import { DEV } from './config';

const splash = document.getElementById('splash');
if (splash) splash.remove();

const parent = document.getElementById('game') ?? undefined;

const game = new Phaser.Game({
  type: Phaser.AUTO,
  parent,
  backgroundColor: '#1a1a1a',
  scale: {
    mode: Phaser.Scale.RESIZE,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: window.innerWidth,
    height: window.innerHeight
  },
  pixelArt: true,
  physics: {
    default: 'arcade',
    arcade: { gravity: { x: 0, y: 0 }, debug: DEV.debugPhysics }
  },
  scene: [BootScene, MenuScene, GameScene, HudScene, PauseScene],
  fps: { target: 60, forceSetTimeOut: false }
});

// Expose for debugging from the preview console.
(window as unknown as { game: Phaser.Game }).game = game;
